import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Order } from 'src/app/shared';
import { SubSink } from 'subsink';

@Component({
  templateUrl: './download-orders.component.html',
  styleUrls: ['./download-orders.component.sass'],
})
export class DownloadOrdersComponent implements OnInit {
  public orders: Order[] = [];
  private subsink = new SubSink();

  constructor(private activateRouter: ActivatedRoute) {
    this.subsink.sink = this.activateRouter.data.subscribe((data) => {
      if (data) {
        if (data['orders']) {
          this.orders = data['orders'];
        }
      }
    });
  }

  ngOnInit(): void {}
}
